import { getDefaultColumnsSettings } from '../TableColumnsSettings';

import { generateZoomInitialTables } from '../../../util/TableTools';
import { ABR_PLAYTIME, METRICS_PLAYER, SWITCH_COUNT, SWITCH_SUCCESS } from '../ZoomConstants';
import {
   formatTimeNumberInt,
   format_0dot00_Number,
   format_time_Number,
   getIntegerWithDecimalSeparator,
} from '../../../util/NumberFormatter';

export const ABR_SETTINGS = {
   [ABR_PLAYTIME]: {
      title: (profile) => `ABR Profile '${profile}'`,
      exIndexName: METRICS_PLAYER,
      initialTable: generateZoomInitialTables(['abrPlaytime']),
      path: 'abr/profiles/use',
      urlAddon: (profile) => `&zoomMetric=${profile}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['Profile'],
         propNames: ['abrPlaytime'],
      },
      dynamicLabelFn: (label, term) => `${label} '${term}'`,
      dataFieldNames: ['playtime', 'latency', 'bufferingRatio'],
      columnNames: ['Total playtime', 'Avg. latency', 'Play buffering ratio'],
      formatters: [
         (cell) => formatTimeNumberInt(cell),
         (cell) => format_time_Number(cell),
         (cell) => `${format_0dot00_Number(cell)} %`,
      ],
      columnsSettings: getDefaultColumnsSettings,
   },
   [SWITCH_COUNT]: {
      title: (term) => `${term === 'total' ? 'up/down' : term} switches`,
      exIndexName: METRICS_PLAYER,
      initialTable: generateZoomInitialTables(['switchCounts']),
      path: 'abr/switches/count',
      urlAddon: (term) => `&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['switches'],
         propNames: ['switchCounts'],
      },
      dynamicLabelFn: (label, term) => `${term === 'total' ? 'up/down' : term} ${label}`,
      dataFieldNames: ['count', 'uniqueCount'],
      columnNames: ['Total count', 'Playback session count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell), (cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
   [SWITCH_SUCCESS]: {
      title: (term) => `${term === 'success' ? 'successful' : 'failed'} switches`,
      exIndexName: METRICS_PLAYER,
      initialTable: generateZoomInitialTables(['switchSuccess']),
      path: 'abr/switches/success',
      urlAddon: (term) => `&zoomMetric=${term}`,
      dataAccessFn: (res) => res.data,
      categories: {
         labels: ['switches'],
         propNames: ['switchSuccess'],
      },
      dynamicLabelFn: (label, term) => `${term === 'success' ? 'successful' : 'failed'} ${label}`,
      dataFieldNames: ['count', 'uniqueCount'],
      columnNames: ['Total count', 'Playback session count'],
      formatters: [(cell) => getIntegerWithDecimalSeparator(cell), (cell) => getIntegerWithDecimalSeparator(cell)],
      columnsSettings: getDefaultColumnsSettings,
   },
};
